export default "__VITE_PUBLIC_ASSET__b83c6452__"